var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgFacebookMin = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 18,
    viewBox: "0 0 8 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.84231 9.06546V17.1247C1.84231 17.2411 1.93414 17.3333 2.05012 17.3333H5.03197C5.14796 17.3333 5.23978 17.2411 5.23978 17.1247V8.93446H7.40004C7.50637 8.93446 7.59819 8.85197 7.60785 8.74038L7.81566 6.27555C7.82532 6.15425 7.72867 6.04751 7.60785 6.04751H5.23978V4.29593C5.23978 3.88351 5.57324 3.55357 5.9792 3.55357H7.64651C7.76249 3.55357 7.85433 3.46139 7.85433 3.34494V0.875263C7.85433 0.758814 7.76249 0.666626 7.64651 0.666626H4.83382C3.181 0.666626 1.84231 2.01063 1.84231 3.67002V6.04751H0.353811C0.237823 6.04751 0.145996 6.1397 0.145996 6.25615V8.72097C0.145996 8.83742 0.237823 8.9296 0.353811 8.9296H1.84231V9.06546Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFacebookMin, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/facebookMin.787964e4.svg";
export { ForwardRef as ReactComponent };